module.exports = __webpack_public_path__ + "static/media/cam-1.19357840.webp";